import styles from './index.module.scss'
import './index.module.scss'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Ticker from './../../components/Ticker/index';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import DisplayText from '../../../../components/DisplayText';
const Trust = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div className={`${!isMobile && `mb-[200px]`}`}>
      {/*<div className={`${styles.trustSubtitle} mb-[20px]`}>*/}
      {/*  Where autonomous capital is already operating.*/}
      {/*</div>*/}
      <div className={`${styles.trustTitle} max-w-[1000px] h-[178px] m-auto text-center mb-[20px]`}>
        <DisplayText fullText="Where autonomous capital is already operating" />
      </div>
      <div className={`${styles.card} relative`}>
        <div className={`${styles.mask} absolute left-0 h-full top-0 right-0 z-10`}></div>
        <Ticker />
      </div>
    </div>
  )
}

export default Trust